import React, {useEffect, useState} from 'react';
import 'styles/pictures/NiceButton.css';
import ShareIcon from 'util/svg/nicebutton/ShareIcon';
import PinIcon from 'util/svg/nicebutton/PinIcon';
import ClipboardIcon from "../../util/svg/nicebutton/ClipboardIcon";
import ArrowShareIcon from "../../util/svg/nicebutton/ArrowShareIcon";
import DownloadIcon from "../../util/svg/nicebutton/DownloadIcon";

const NiceButton = ({
                        children,
                        onClick,
                        text,
                        disabled = false,
                        showShareIcon = false,
                        showPinIcon = false,
                        large = false,
                        mergeOnLeft = false,
                        mergeOnRight = false,
                        minWidthForGet = false,
                        showArrowShareIcon = false,
                        showClipboardIcon = false,
                        showDownloadIcon = false,
                        borderWall = false
                    }) => {
    const [hover, setHover] = useState(false);
    const [cssStyle, setCssStyle] = useState('nice-button');

    const clicked = () => {
        if (!disabled) {
            onClick();
        }
    };

    useEffect(() => {
        const classes = [
            'nice-button',
            disabled && 'disabled',
            hover && !disabled && 'hover',
            large && 'large',
            mergeOnLeft && 'merge-to-left',
            mergeOnRight && 'merge-to-right',
            minWidthForGet && 'min-width-for-get',
            borderWall && 'border-wall'
        ].filter(Boolean); // Remove falsy values (null, undefined, false)

        setCssStyle(classes.join(' ')); // Join with a single space
    }, [disabled, hover, large, mergeOnLeft, mergeOnRight]);

    return (
        <div
            className={cssStyle}
            onClick={clicked}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {showShareIcon && <ShareIcon size={'20px'} color={hover ? '#3f5743' : '#4E6C55'}/>}
            {showPinIcon && <PinIcon color={hover ? '#3f5743' : '#4E6C55'}/>}
            {showArrowShareIcon && <ArrowShareIcon color={hover ? '#3f5743' : '#4E6C55'}/>}
            {showClipboardIcon && <ClipboardIcon color={hover ? '#3f5743' : '#4E6C55'}/>}
            {showDownloadIcon && <DownloadIcon color={hover ? '#3f5743' : '#4E6C55'}/>}
            {text}
            {children}
        </div>
    );
};

export default NiceButton;